import Box from '@mui/material/Box'
import { PositionHoof } from 'models'
import { useMemo } from 'react'
import { COLORS } from 'styles/colors'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'

import { CounterSpan, HoofPositionsSchema } from './components'
import { hoofLabels } from './helpers/getLabel'

interface IHoofPickerProps {
	placement: PositionHoof
	count: number
	onClick: () => void
	active: boolean
	hasError?: boolean
}

/**
 * HoofPicker — кнопка выбора копыта с визуальной схемой и счётчиком.
 *
 * Props:
 * - placement: PositionHoof — определяет, какое копыто будет активно (Front_Left, Front_Right, Rear_Left, Rear_Right)
 * - count: number — количество событий или показателей для этого копыта
 * - onClick: () => void — обработчик клика
 * - active: boolean — подсвечивает активное состояние и меняет цвет заливки
 *
 * Использование:
 * <HoofPicker
 *   placement={PositionHoof.Front_Left}
 *   count={2}
 *   active={true}
 *   onClick={() => console.log('Clicked')}
 * />
 */
export const HoofPicker = ({
	placement,
	count,
	onClick,
	active,
	hasError = false,
}: IHoofPickerProps) => {
	const label = useMemo(() => hoofLabels[placement], [placement])
	const isZeroCount = count === 0

	return (
		<Box
			onClick={onClick}
			component='button'
			sx={{
				cursor: 'pointer',
				padding: '8px',
				position: 'relative',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'space-between',
				width: '107px',
				height: '107px',
				borderRadius: '8px',
				border: active
					? 'none'
					: `1px solid ${hasError ? COLORS.health : COLORS.icon}`,
				boxShadow: active ? `0 0 0 2px ${COLORS.main}` : 'none',
				backgroundColor: active ? COLORS.health : '#fff',
			}}
		>
			<HoofPositionsSchema
				placement={placement}
				active={active}
				count={count}
			/>
			<TypographySecondary14
				sx={{
					color: active ? '#fff' : COLORS.secondary,
				}}
			>
				{label}
			</TypographySecondary14>
			{!isZeroCount && <CounterSpan active={active} count={count} />}
		</Box>
	)
}
